module.exports = "<div ng-controller=\"ConversionLogControllerName as $ctrl\">\n    <conversion-log-table filter='filter'></conversion-log-table>\n</div>\n";